import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DomSanitizer } from '@angular/platform-browser';
import { ScrollToService } from '@nicky-lenaers/ngx-scroll-to';
import { Lightbox } from 'ngx-lightbox';
import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { RequestService } from '@providers/request/request.service';
import { RequestV2Service } from '@providers/request-service-v2/request-v2.service';
var ServiceComponent = /** @class */ (function () {
    function ServiceComponent(requestService, breakpointObserver, globalDataService, scrollToService, sanitization, requestV2Service, lightbox) {
        var _this = this;
        this.requestService = requestService;
        this.globalDataService = globalDataService;
        this.scrollToService = scrollToService;
        this.sanitization = sanitization;
        this.requestV2Service = requestV2Service;
        this.lightbox = lightbox;
        // doublon check validated dans chapter
        this.isDesktop = false;
        breakpointObserver.observe(['(min-width: 800px)']).subscribe(function (result) {
            _this.isDesktop = result.matches;
            _this.user = _this.globalDataService.getUser();
        });
    }
    ServiceComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var materialsResult;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stepIsAgreementOrDesign = this.checkAgreementOrDesignStep();
                        return [4 /*yield*/, this.requestV2Service
                                .getQuotationMaterials(this.service.id, null, true, 'all', 'false')];
                    case 1:
                        materialsResult = _a.sent();
                        this.materials = materialsResult.items;
                        return [2 /*return*/];
                }
            });
        });
    };
    ServiceComponent.prototype.checkAgreementOrDesignStep = function () {
        var steps = this.globalDataService.steps
            .filter(function (pS) { return pS.slug === 'agreement_signed' || pS.slug === 'design'; }).map(function (pS) { return pS.id; });
        return steps.includes(this.project.id_project_step);
    };
    ServiceComponent.prototype.calculateUnitServicePrice = function () {
        var _this = this;
        if (this.globalDataService.financial) {
            var findChapter = this.globalDataService.financial.customer.chapters
                .find(function (i) { return i.id_quotation_chapter === _this.service.id_quotation_chapter; });
            if (findChapter) {
                var service = findChapter.services.find(function (i) { return i.id_quotation_service === _this.service.id; });
                return service.total;
            }
        }
        return 0;
    };
    // doublon check validated dans chapter
    ServiceComponent.prototype.checkValidated = function (validated) {
        return !validated ? 'quot-service-grayed' : '';
    };
    ServiceComponent.prototype.getColSpan = function () {
        if (!this.isDesktop) {
            return 6;
        }
        var length = this.materials.length;
        if (length > 2) {
            return 2;
        }
        return 3;
    };
    ServiceComponent.prototype.getPhoto = function (id) {
        var result;
        if (typeof id !== 'undefined') {
            result = this.sanitization
                .bypassSecurityTrustUrl(environment.api_url + "/images/" + id + "?size=70x70");
        }
        return result;
    };
    ServiceComponent.prototype.openPhoto = function (material) {
        var photosToOpen = [];
        if (material
            && material._related
            && material._related.material_version_images) {
            material._related.material_version_images.forEach(function (photo) {
                photosToOpen.push({
                    src: environment.api_url + "/images/" + photo.id_image + "?size=350x650",
                    thumb: photo.id_image
                });
            });
        }
        this.lightbox.open(photosToOpen, 0, { wrapAround: true, showImageNumberLabel: true });
    };
    ServiceComponent.prototype.isOption = function () {
        return this.service.type.includes('option');
    };
    return ServiceComponent;
}());
export { ServiceComponent };
